import StorageService from 'tradera/services/storage-service';
import { STORAGE_KEYS } from 'tradera/constants/storage';
import type { RecentSearch } from 'tradera/state/personalisation/reducer';

const recentSearchesService = new StorageService(STORAGE_KEYS.SEARCH_RECENT);
const recentBrandAttributesService = new StorageService(
    STORAGE_KEYS.RECENT_BRAND_ATTRIBUTES,
);

type RecentSearchFromLocalStorage = Omit<RecentSearch, 'text'>;

type LegacyRecentSearchFromLocalStorage = number;

export const getRecentSearchesLocalStorage = (): RecentSearch[] => {
    const recentSearches = recentSearchesService
        .fetch<
            RecentSearchFromLocalStorage | LegacyRecentSearchFromLocalStorage
        >()
        .orderByTimestamp?.();

    const formattedRecentSearches = recentSearches?.map((recent) => {
        return {
            text: recent.key,
            count:
                typeof recent.value === 'number'
                    ? recent.value
                    : recent.value?.count,
            queryParams:
                typeof recent.value === 'object'
                    ? recent.value?.queryParams
                    : { q: recent.key },
        };
    });

    return formattedRecentSearches ?? [];
};

export const setRecentSearchLocalStorage = (
    searchTerm: string,
    queryParams: object,
    count: number,
) => {
    recentSearchesService.set(searchTerm, {
        count,
        queryParams,
    });
};

export const removeRecentSearchLocalStorage = (searchTerm: string) => {
    if (!searchTerm || searchTerm.length < 3) {
        return;
    }
    recentSearchesService.remove(searchTerm);
};

export const setRecentBrandAttributesLocalStorage = (
    filter: string,
    value: string,
) => {
    recentBrandAttributesService.set(filter, value);
};

export const getRecentBrandAttributesLocalStorage = () => {
    const recentBrandAttributes = recentBrandAttributesService
        .fetch()
        .orderByTimestamp?.()
        .find((item) => item.value && item.key);
    const recentBrand = {
        filter: recentBrandAttributes?.key || null,
        value: recentBrandAttributes?.value || null,
    };
    return recentBrand.filter && recentBrand.value ? recentBrand : {};
};
